import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IPrayerTopic } from '../providers/interfaces';
import { IListMeta } from '../providers/lectures.service';
import { PrayerTopicsService } from '../providers/prayer-topics.service';

@Component({
  selector: 'app-prayer-topics',
  templateUrl: './prayer-topics.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./prayer-topics.component.scss']
})
export class PrayerTopicsComponent implements OnInit {

  public prayerTopics$: Observable<IPrayerTopic[]>;
  public meta$: Observable<IListMeta>;

  public page = 1;
  public pageSize = 4;
  public startDate = new Date( 0 );
  public endDate = new Date();

  constructor(
    private $prayerTopicsService: PrayerTopicsService,
  ) {

    this.prayerTopics$ = this.$prayerTopicsService.selectPrayerTopicsAllFetch();
    this.meta$ = this.$prayerTopicsService.meta$.asObservable();
  }

  ngOnInit() {
    console.log( '[PRAYER-TOPICS]: Init' );
    this.fetch();
  }

  filter() {
    this.page = 1;
    console.log( '[PRAYER-TOPICS]: Filter' );
    this.fetch();
  }


  fetch() {
    console.log( '[PRAYER-TOPICS]: Fetch' );
    this.$prayerTopicsService.dispatchPrayerTopicsAllFetch( this.page, this.pageSize );
  }

  paginate( newPage ) {
    console.log( '[PRAYER-TOPICS]: Paginate', newPage );
    this.page = newPage;
    this.fetch();
  }
}



// WEBPACK FOOTER //
// ./src/app/prayer-topics/prayer-topics.component.ts